import { useState } from "react";
import { useI18n } from "@/i18n/i18n";

/** Pieza de la oración con su traducción al inglés: al pasar el mouse (o tocar en el celular)
 *  muestra la frase completa en inglés y, debajo, palabra por palabra. */
export const GlossPiece = ({ gloss, text, className = "", onUse, testId }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const label = text ?? gloss?.es ?? "";
  if (!gloss || (!gloss.en && !(gloss.words || []).length)) {
    return <span className={className}>{label}</span>;
  }

  const show = () => { if (!open) { setOpen(true); onUse?.(); } };

  return (
    <span className="relative inline-block"
          onMouseEnter={show} onMouseLeave={() => setOpen(false)}
          onClick={(e) => { e.stopPropagation(); open ? setOpen(false) : show(); }}>
      <span className={`${className} cursor-help border-b border-dashed border-slate-300`}
            data-testid={testId}>
        {label}
      </span>
      {open && (
        <span className="absolute z-40 left-0 top-full mt-1 w-max max-w-[22rem] rounded-xl border
                         border-slate-200 bg-white p-3 shadow-xl text-left"
              data-testid={testId ? `${testId}-tip` : undefined}>
          {gloss.en && (
            <span className="block text-sm font-semibold text-slate-900">{gloss.en}</span>
          )}
          {!!(gloss.words || []).length && (
            <span className="block mt-2 pt-2 border-t border-slate-100">
              {gloss.words.map((w, i) => (
                <span key={`${w.es}-${i}`} className="block text-xs text-slate-500 leading-5">
                  <span className="font-medium text-slate-700">{w.es}</span> · {w.en}
                </span>
              ))}
            </span>
          )}
          <span className="block mt-2 text-[10px] uppercase tracking-wide text-amber-600">
            {t("cj_help_cost")}
          </span>
        </span>
      )}
    </span>
  );
};
